// src/store/adminStore.js
//
// Estado global del dashboard.
// Maneja: sesión admin, torneo activo, resumen en vivo.

import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { loginAdmin, getResumenEvento } from '@/utils/api_admin'
import { getTorneoActivo } from '@/utils/api_backend'

export const useAdminStore = defineStore('admin', () => {

  // ── Sesión ───────────────────────────────────────────────────────────────
  const token    = ref(localStorage.getItem('admin_token') || null)
  const admin    = ref(JSON.parse(localStorage.getItem('admin_user') || 'null'))
  const torneoId = ref(localStorage.getItem('admin_torneo_id') || null)

  const estaAutenticado = computed(() => !!token.value)

  async function login(email, password) {
    const data = await loginAdmin({ email, password })
    token.value = data.access
    admin.value = data.admin
    localStorage.setItem('admin_token',   data.access)
    localStorage.setItem('admin_refresh', data.refresh)
    localStorage.setItem('admin_user',    JSON.stringify(data.admin))

    // Obtener y guardar el torneo activo automáticamente al hacer login
    try {
      const torneo = await getTorneoActivo()
      if (torneo?.id) setTorneo(torneo.id)
    } catch (e) {
      console.warn('[adminStore] No se pudo obtener el torneo activo:', e)
    }

    return data
  }

  function logout() {
    token.value    = null
    admin.value    = null
    torneoId.value = null
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_refresh')
    localStorage.removeItem('admin_user')
    localStorage.removeItem('admin_torneo_id')
  }

  function setTorneo(id) {
    torneoId.value = String(id)
    localStorage.setItem('admin_torneo_id', String(id))
  }

  // ── Resumen en vivo ───────────────────────────────────────────────────────
  const resumen         = ref(null)
  const cargandoResumen = ref(false)
  let   resumenInterval = null

  async function cargarResumen() {
    if (!torneoId.value) return
    try {
      cargandoResumen.value = true
      resumen.value = await getResumenEvento(torneoId.value)
    } catch (e) {
      console.error('[adminStore] Error cargando resumen:', e)
    } finally {
      cargandoResumen.value = false
    }
  }

  function iniciarPollingResumen(intervaloMs = 15_000) {
    cargarResumen()
    resumenInterval = setInterval(cargarResumen, intervaloMs)
  }

  function detenerPollingResumen() {
    if (resumenInterval) {
      clearInterval(resumenInterval)
      resumenInterval = null
    }
  }

  return {
    // sesión
    token, admin, torneoId, estaAutenticado,
    login, logout, setTorneo,
    // resumen
    resumen, cargandoResumen,
    cargarResumen, iniciarPollingResumen, detenerPollingResumen,
  }
})